import { Component, HostBinding } from '@angular/core';
import "@neb/lit-storybook";

@Component({
  selector: 'gems-spinner',
  templateUrl: 'gems-spinner.component.html',
  standalone: false
})
export class GemsSpinnerComponent {
  @HostBinding('class') class = 'd-flex f-1';
}
